import _mapValues from 'lodash/mapValues';

import request from './request.service';
import { api } from '../config';
import { downloadFile } from '../utils';

const COLUMNS_WITH_RANGE = ['numberOfAppliances', 'revenue', 'appliances'];
const COLUMNS_WITH_DATE = ['expirationDate', 'firstAdd', 'opportunityDateClosed'];

export const transformFilter = (filter, brand, field) => {
  const transformedFilter = _mapValues(filter, (value, key) => {
    if (COLUMNS_WITH_RANGE.includes(key)) return value;
    if (COLUMNS_WITH_DATE.includes(key)) {
      if (value.Exact) {
        value = { From: value.Exact, To: value.Exact };
      }
      return value;
    }
    const values = Object.keys(value);
    return values.filter(key => value[key]);
  });

  const finalFilter = { ...transformedFilter, brand };
  if (field && finalFilter[field]) {
    delete finalFilter[field];
  }
  return finalFilter;
};

export const findQuotes = async body => {
  const response = await request(api.findQuotes, {
    method: 'POST',
    body,
  });
  return response.body;
};

export const getTotalAppliances = async body => {
  const response = await request(api.getTotalAppliances, {
    method: 'POST',
    body,
  });
  return response.body;
};

export const updateQuoteById = async (_id, field, value) => {
  const response = await request(api.updateQuote, {
    method: 'POST',
    body: {
      update: {
        _id,
        field,
        value,
      },
    },
  });
  return response.body;
};

export const updateQuoteMultiFieldsById = async (_id, values) => {
  const response = await request(api.updateQuoteMultiFields, {
    method: 'POST',
    body: {
      update: {
        _id,
        values,
      },
    },
  });
  return response.body;
};

export const findValues = async body => {
  const response = await request(api.findValues, {
    method: 'POST',
    body,
  });
  if (response.body && response.body.id === body.id) {
    return response.body.values;
  }
  return null;
};

export const addQuote = async body => {
  const response = await request(api.addQuote, {
    method: 'POST',
    body,
  });
  return response.body;
};

export const exportToExcel = async body => {
  try {
    const response = await request(api.exportToExcel, {
      method: 'POST',
      responseType: 'blob',
      body,
    });

    downloadFile(response);
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const getMTMList = async () => {
  const response = await request(api.getMTMList);
  return response.body;
};
